// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1hBoY","title":"AfterBackImages_title__39Uo7","images":"AfterBackImages_images__2zVWC"};